import { Button, buttonColors, buttonSizes, buttonTypes } from "../.."
import { StarIcon } from "../../../assets/icons"

import styles from "./pwaInstallCard.module.css"

export type PwaInstallCardProps = {
  appIcon: string
  appName: string
  buttonText: string
  onInstall: () => void
  showRating?: boolean
  ratingCount?: number
}

export const PwaInstallCard = ({
  appIcon,
  appName,
  buttonText,
  onInstall,
  showRating = true,
  ratingCount = 5,
}: PwaInstallCardProps) => {
  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <img src={appIcon} alt={appName} className={styles.iconImage} />
      </div>
      <p className={styles.appName}>{appName}</p>
      {showRating && ratingCount > 0 && (
        <div className={styles.ratingRow} aria-label={`Rating ${ratingCount} out of 5`}>
          {Array.from({ length: ratingCount }).map((_, idx) => (
            <span key={idx} className={styles.ratingIcon}>
              <StarIcon />
            </span>
          ))}
        </div>
      )}
      <Button
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          onInstall()
        }}
        type={buttonTypes.OUTLINE}
        color={buttonColors.PRIMARY}
        size={buttonSizes.SMALL}
      >
        {buttonText}
      </Button>
    </div>
  )
}
